export const DONUT_TOP_N = 7;

export const DONUT_COLORS: string[] = [
  '#5B9BD5',
  '#00D97E',
  '#6366F1',
  '#395E94',
  '#FF8C42',
  '#9B59B6',
  '#2C4A73',
];

export const DONUT_OTHER_COLOR = '#9CA3AF';
